import { useMemo } from "react";
import { useSchedulerStore } from "../state/scheduler.store";

export const useMeetingLinkTimezone = () => {
  const { sessionData, actions } = useSchedulerStore();

  const setTimezone = (timezone: string) => {
    actions.setSessionData({ ...sessionData, selectedTimezone: timezone });
  };

  const currentTimezone = useMemo(
    () => sessionData?.selectedTimezone,
    [sessionData?.selectedTimezone]
  );

  return { currentTimezone, setTimezone };
};
